import React, { useState, useEffect } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./cv.css";
import Bluebutton from "../../components/blueButton/Bluebutton";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import API_URL from "../../constants";
import Container from "react-bootstrap/Container";
const Jobs = () => {
  const { id } = useParams();
  // console.log("id", id);
  const location = useLocation();
  const [data, setdata] = useState();
 
  useEffect(() => {
    // Define an async function inside the useEffect hook
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/applications/job_details`,
          { params: { job_id: id } }
        );
        console.log("Job details fetched successfully:", response.data);
        setdata(response.data.job);
      } catch (error) {
        console.error("Error fetching job details:", error);
      }
    };

    // Call the async function
    fetchData();

    // Cleanup function (if needed)
    return () => {
      // Perform cleanup actions if necessary
    };
  }, [id]); // Make sure to include 'id' in the dependency array if it's a prop or state

  // const data = location.state.data;
  console.log("data", data);
  const [apply, setApply] = useState(false);
  const [resume, setResume] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
    location: "",
    years_of_experience: "",
    current_salary: "",
    expected_salary: "",
    skills: [],
    current_position: "",
    current_company: "",
    resume: "",
  });
  useEffect(() => {
    // This effect will run whenever the resume state changes
    if (resume) {
      console.log("Resume file:", resume);
      // You can also log the file name or other properties
      console.log("Resume file name:", resume.name);
    } else {
      console.log("No resume file selected");
    }

    // Clean up function (optional)
    return () => {
      console.log("Cleaning up resume effect");
    };
  }, [resume]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const resumeUpload = async () => {
    try {
      if (resume) {
        console.log("Resume file11:", resume);
        // You can also log the file name or other properties
        console.log("Resume file name11:", resume.name);
      } else {
        console.log("No resume file selected11");
      }
      const formData = new FormData();
      formData.append("resume", resume);
      const response = await axios.post(
        `${API_URL}/applications/upload-resume`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(
        "File uploaded successfully. Location:",
        response.data.fileLocation
      );
      return response.data.fileLocation;
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (!formData[key] && key !== "resume") {
        alert(`Please fill in ${key}`);
        return;
      }
    }

    if (!resume) {
      alert("Please upload a resume");
      return;
    }

    // console.log("respresume", resp);

    const rep = await resumeUpload();
    console.log("rep", rep);
    const dataToSend = {
      ...formData, // Spread the formData object
      resume: rep,
      job_id: id,
    };
    console.log("dataToSend", dataToSend);
    try {
      const response = await axios.post(
        `${API_URL}/applications/apply`,
        dataToSend
      );
      console.log("Response:", response.data);
      alert("Submitted successfully!");
      if (response.status === 200 || response.status === 201) {
          const dataToSend = {
            to: formData.email,
            subject: `Job Application Submitted for ${data.post}`,
            message: `
          Dear ${formData.name},

          Thank you for submitting your job application. Here are the details you provided:

          Name: ${formData.name}
          Phone Number: ${formData.phone_number}
          Email: ${formData.email}
          Location: ${formData.location}
          Years of Experience: ${formData.years_of_experience}
          Current Salary: ${formData.current_salary}
          Expected Salary: ${formData.expected_salary}
          Skills: ${formData.skills.join(", ")}
          Current Position: ${formData.current_position}
          Current Company: ${formData.current_company}

          We appreciate your interest in joining our team and will review your application shortly.

          Best regards,
          Udaya Solution
        `,
          };

          const mailresponse = await axios.post(
            `${API_URL}/send-email`,
            dataToSend
          );
          console.log("mailresponse", mailresponse);

          // if (mailresponse.status === 200 || mailresponse.status === 201) {
          //   alert("submitted successfully!");
          //   // setSuccess(true);
          // }
        }
        setFormData({
          name: "",
          phone_number: "",
          email: "",
          location: "",
          years_of_experience: "",
          current_salary: "",
          expected_salary: "",
          skills: [],
          current_position: "",
          current_company: "",
          resume: "",
        });
      // alert("mailed submitted successfully!");
      // Show a notification message
    } catch (error) {
      console.error("Error:", error);
      console.error("Error Response:", error.response); // Log the error response
    }
    // Here you can perform further actions like submitting the form data to a server
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setResume(file);
  };
  const handleChangeSkills = (e) => {
    const { name, value } = e.target;
    // Convert comma-separated string to array
    const skillsArray = value.split(",").map((skill) => skill.trim());
    setFormData({ ...formData, [name]: skillsArray });
  };


  return (
    <>
      <Navb />
      {!apply ? (
        <Container className={`client_Detail ${apply ? "hidden" : ""}`}>
          {data ? (
            <>
              <div className=" dashboardCandidate">Job Details</div>
              <div className="viewjobField">
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Title: </div>
                  <div className="viewjobinputField">{data.post}</div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Company Name: </div>
                  <div className="viewjobinputField">{data.company_name}</div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Location: </div>
                  <div className="viewjobinputField">{data.location}</div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Years Of Experience:</div>
                  <div className="viewjobinputField">
                    {data.years_of_experience}
                  </div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Number Of Openings: </div>
                  <div className="viewjobinputField">{data.openings}</div>
                </div>

                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Mode of Work: </div>
                  <div className="viewjobinputField">{data.remote}</div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Salary Offered: </div>
                  <div className="viewjobinputField">{data.salary_offered}</div>
                </div>

                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Keywords:</div>
                  <div className="viewjobinputField">
                    {data.keywords.join(", ")}
                  </div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Skills:</div>
                  <div className="viewjobinputField">
                    {data.skills.join(", ")}
                  </div>
                </div>
                <div className="viewjobwrapper_input">
                  <div className="viewjobTitle">Job Description:</div>
                  <div className="viewjobinputField">
                    {data.job_description}
                  </div>
                </div>
              </div>
              {/* <div className="allInputField">
                <InputGroup className="mb-3">
                  <div className="wrapper_input">
                    <div className="jobTitle">Company Name: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.company_name}
                      aria-describedby="basic-addon1"
                      type="text"
                      aria-label="name"
                      name="company_name"
                      disabled
                    />
                  </div>

                  <div className="wrapper_input">
                    <div className="jobTitle">Location: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.location}
                      aria-describedby="basic-addon1"
                      type="text"
                      aria-label="name"
                      name="location"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Number Of Openings: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.openings}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="openings"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Title: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.post}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="post"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Mode of Work: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.remote}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="remote"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Salary Offered: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.salary_offered}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="salary_offered"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Years Of Experience: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.years_of_experience}
                      aria-label="years_of_experience"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="years_of_experience"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Status: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.status}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="status"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Keywords: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.keywords}
                      aria-label="keywords"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="keywords"
                      disabled
                    />
                  </div>
                  <div className="wrapper_input">
                    <div className="jobTitle">Skills: </div>
                    <Form.Control
                      className="inputField"
                      placeholder={data.skills}
                      aria-label="name"
                      aria-describedby="basic-addon1"
                      type="text"
                      name="skills"
                      disabled
                    />
                  </div>

                  <div className="wrapper_input">
                    <div className="jobTitle">Job Description: </div>
                    <Form.Control
                      as="textarea"
                      className="inputField"
                      placeholder={data.job_description}
                      aria-describedby="basic-addon1"
                      type="text"
                      style={{ height: "150px" }}
                      aria-label="name"
                      name="job_description"
                      disabled
                    />
                  </div>
                </InputGroup>
              </div> */}
            </>
          ) : (
            <div>No data available</div>
          )}
          <button
            className="bluebutton"
            onClick={(e) => {
              e.preventDefault();
              setApply(true);
            }}
          >
            Apply
          </button>
        </Container>
      ) : (
        <div className={`applyForm ${apply ? "visible" : ""}`}>
          <div className="jobHeader">Submit Your CV</div>
          <Form onSubmit={handleSubmit}>
            <div className="allField">
              <InputGroup className="mb-3">
                {/* <InputGroup.Text id="basic-addon1">@</InputGroup.Text> */}
                <Form.Control
                  className="field"
                  placeholder="Name"
                  aria-label="name"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Phone_number"
                  aria-label="phone_number"
                  aria-describedby="basic-addon1"
                  type="number"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Email"
                  aria-label="email"
                  aria-describedby="basic-addon1"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Location"
                  aria-label="location"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Years_of_experience"
                  aria-label="years_of_experience"
                  aria-describedby="basic-addon1"
                  type="number"
                  name="years_of_experience"
                  value={formData.years_of_experience}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Current_salary"
                  aria-label="current_salary"
                  aria-describedby="basic-addon1"
                  type="number"
                  name="current_salary"
                  value={formData.current_salary}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Expected_salary"
                  aria-label="expected_salary"
                  aria-describedby="basic-addon1"
                  type="number"
                  name="expected_salary"
                  value={formData.expected_salary}
                  onChange={handleChange}
                  required
                />
                {/* <Form.Control
                  className="field"
                  placeholder="Skills"
                  aria-label="skills"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="skills"
                  value={formData.skills}
                  onChange={handleChange}
                  required
                /> */}
                <Form.Control
                  className="field"
                  placeholder="Skills (comma-separated)"
                  aria-label="skills"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="skills"
                  value={formData.skills.join(",")} // Convert array to comma-separated string
                  onChange={handleChangeSkills} // New handler for skills change
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Current_position"
                  aria-label="current_position"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="current_position"
                  value={formData.current_position}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder="Current_company"
                  aria-label="current_company"
                  aria-describedby="basic-addon1"
                  type="text"
                  name="current_company"
                  value={formData.current_company}
                  onChange={handleChange}
                  required
                />
                <Form.Control
                  className="field"
                  placeholder={`Post : ${data.post}`}
                  aria-label="current_company"
                  aria-describedby="basic-addon1"
                  type="text"
                  name={data.job_id}
                  disabled
                />
                <Form.Control
                  className="field"
                  placeholder={`Job Id: ${data.job_id}`}
                  aria-label="current_company"
                  aria-describedby="basic-addon1"
                  type="text"
                  name={data.job_id}
                  disabled
                />
                <Form.Control
                  className="field"
                  type="file"
                  name="resume"
                  onChange={handleFileChange}
                  required
                />
              </InputGroup>
              <div className="center">
                <button className="bluebutton" type="submit">
                  Submit
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Jobs;
